import { initializeMessageBus } from '@execonline-inc/message-bus.private';
import { assertNever } from '@kofno/piper';
import { readVarM } from '../Assertions/environments';
import { InactivityLogoutTracker } from '../Inactivity/Core';

export const { MessageBus, useMessageBus } = initializeMessageBus({
  whoami: 'adminstudio',
  portalHost: readVarM('VITE_MESSAGE_BUS_PORTAL_HOST'),
  onMessage: (message) => {
    switch (message.kind) {
      case 'user-activity':
        InactivityLogoutTracker.activeExternally(message.expiration);
        break;
      default:
        assertNever(message.kind);
    }
  },
});
